import { getLmsCourseCategoryPresentation } from "@/components/lms/lmsCourseCategoryPresentation";

interface Props {
  category?: { id?: string | null; name?: string | null } | null;
  fallbackLabel?: string;
}

export default function LmsCategoryDepiction({
  category,
  fallbackLabel = "-",
}: Props) {
  const label = category?.name?.trim() || fallbackLabel;
  const backgroundColor = getLmsCourseCategoryPresentation(category).color;

  return (
    <span
      style={{
        alignItems: "center",
        backgroundColor,
        borderRadius: "999px",
        color: "#ffffff",
        display: "inline-flex",
        fontSize: "0.875rem",
        fontWeight: 600,
        gap: "0.45rem",
        maxWidth: "100%",
        padding: "0.25rem 0.65rem",
      }}
    >
      <span
        aria-hidden
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "50%",
          flexShrink: 0,
          height: "0.55rem",
          width: "0.55rem",
        }}
      />
      <span
        style={{
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </span>
    </span>
  );
}
